// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1Rkr5","col":"Table_col__15nWf","fulfillmentStatus":"Table_fulfillmentStatus__1bENW","emailCol":"Table_emailCol__3lz8R"};